const Detector = require('./base.js');

const SYNONYMS = [
  'trade',
  'traded',
  'trader',
  'traders',
  'trading',
  'swap',
];
const NAMESPACE = 'trade';

module.exports = new Detector(SYNONYMS, NAMESPACE);



// WEBPACK FOOTER //
// ./javascripts/components/detector/trade.js